import { message } from 'antd';
import { createMatchSelector, push } from 'connected-react-router';
import { updateItemCart } from 'containers/MainLayout/actions';
import { call, fork, put, select, take } from 'redux-saga/effects';
import translations from 'translations';
import { bulkReorder, getFulfillmentNote, submitFeedback } from 'utils/apollo';
import { EventName, sendGA4Event } from 'utils/triggerGA4Event';
import ordersMessages from '../../containers/OrdersPage/messages';
import { bulkReorder as bulkReorderActions, fulfillmentNote as fulfillmentNoteActions, ratingAction } from './actions';
import ActionTypes from './constants';

function* initData() {
  yield put(fulfillmentNoteActions.request());
  const route = yield select(createMatchSelector('/phieu-giao/:id'));
  const response = yield call(getFulfillmentNote, {
    id: route.params.id,
  });
  if (response.errors) {
    yield put(fulfillmentNoteActions.failure(response.errors));
  } else {
    yield put(fulfillmentNoteActions.success(response));
  }
}

function* bulkReOrderFlow() {
  while (true) {
    const { payload } = yield take(ActionTypes.BULK_REORDER);
    yield put(bulkReorderActions.request());

    const response = yield call(bulkReorder, { input: { ...payload } });
    if (!response.errors) {
      yield put(bulkReorderActions.success(response));
      yield put(updateItemCart.success(response.cart));
      yield put(push('/checkout'));
    } else {
      yield put(bulkReorderActions.failure(response.errors));
    }
  }
}

function* ratingFlow() {
  while (true) {
    const { payload } = yield take(ActionTypes.RATE);
    yield put(ratingAction.request());
    const response = yield call(submitFeedback, { input: { ...payload } });

    if (!response.errors) {
      yield put(ratingAction.success({ feedback: response.feedback, objectId: payload.objectId }));
      if (!payload?.dismissed) {
        message.success(translations(ordersMessages.submitFeedbackSuccessfully));
      }
    } else {
      yield put(ratingAction.failure(response.errors));
      sendGA4Event(EventName.SUBMIT_RATING_ERROR, {
        ffm_id: payload.objectId,
      });
      message.error(response.errors[0].message);
    }
  }
}

export default function* fulfillmentNoteDetailPageSaga() {
  yield fork(initData);
  yield fork(bulkReOrderFlow);
  yield fork(ratingFlow);
}
